// Region values stored on admin articles (article.state field)
// and their display labels in Hindi and English.
export const REGION_OPTIONS = [
  { value: 'north_india', labelHi: 'उत्तर भारत', labelEn: 'North India' },
  { value: 'south_india', labelHi: 'दक्षिण भारत', labelEn: 'South India' },
  { value: 'east_india',  labelHi: 'पूर्वी भारत',  labelEn: 'East India'  },
  { value: 'west_india',  labelHi: 'पश्चिम भारत', labelEn: 'West India'  },
];

// Maps each broad region to the state slugs used in StatePage.
// An admin article tagged with a region will appear on all state pages in that region.
export const REGION_TO_STATE_SLUGS = {
  north_india: [
    'delhi', 'uttar-pradesh', 'uttarakhand', 'rajasthan',
    'haryana', 'punjab', 'himachal-pradesh', 'jammu-kashmir',
    'chandigarh', 'ladakh',
  ],
  south_india: [
    'karnataka', 'tamil-nadu', 'kerala', 'telangana',
    'andhra-pradesh', 'puducherry',
  ],
  east_india: [
    'west-bengal', 'odisha', 'bihar', 'jharkhand', 'assam',
    'tripura', 'meghalaya', 'manipur', 'mizoram', 'nagaland',
    'arunachal-pradesh', 'sikkim', 'andaman-nicobar',
  ],
  west_india: [
    'maharashtra', 'gujarat', 'goa', 'dadra-daman-diu',
    'madhya-pradesh', 'chhattisgarh',
  ],
};

/** Return a human-readable region label for a given region value. */
export const getRegionLabel = (regionValue, lang = 'hi') => {
  if (!regionValue) return '';
  const opt = REGION_OPTIONS.find(r => r.value === regionValue);
  if (!opt) return '';
  return lang === 'en' || lang === 'EN' ? opt.labelEn : opt.labelHi;
};

// ── Public-facing regional news pages ────────────────────────────────────────
// Used ONLY by RegionPage and Footer — does NOT affect admin region tagging.
// The five regions match the task specification; Central India is new and has
// no existing admin tag (MP/CG articles are matched via stateSlug directly).
export const REGION_PAGE_CONFIG = [
  {
    slug: 'north-india',
    adminTag: 'north_india',
    labelHi: 'उत्तर भारत',
    labelEn: 'North India',
    states: [
      'delhi', 'haryana', 'himachal-pradesh', 'jammu-kashmir', 'ladakh',
      'punjab', 'uttarakhand', 'uttar-pradesh', 'chandigarh',
    ],
  },
  {
    slug: 'south-india',
    adminTag: 'south_india',
    labelHi: 'दक्षिण भारत',
    labelEn: 'South India',
    states: [
      'andhra-pradesh', 'telangana', 'karnataka', 'kerala', 'tamil-nadu',
      'puducherry', 'lakshadweep', 'andaman-nicobar',
    ],
  },
  {
    slug: 'east-india',
    adminTag: 'east_india',
    labelHi: 'पूर्वी भारत',
    labelEn: 'East India',
    states: [
      'bihar', 'jharkhand', 'odisha', 'west-bengal', 'sikkim',
    ],
  },
  {
    slug: 'west-india',
    adminTag: 'west_india',
    labelHi: 'पश्चिम भारत',
    labelEn: 'West India',
    states: [
      'maharashtra', 'gujarat', 'goa', 'rajasthan', 'dadra-daman-diu',
    ],
  },
  {
    slug: 'central-india',
    adminTag: null,
    labelHi: 'मध्य भारत',
    labelEn: 'Central India',
    states: [
      'madhya-pradesh', 'chhattisgarh',
    ],
  },
];
